// src/Component/legal/TermsGuard.jsx

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { comprovarAcceptacioAction, guardarAcceptacioAction, carregarDocumentAction } from '../../actions/legalAction';
import SpinerLoader from '../../Helpers/SpinerLoader';
// Substitueix les línies dels imports de react-pdf per aquestes:
import { Document, Page, pdfjs } from 'react-pdf/dist/umd/entry.webpack';
import 'react-pdf/dist/umd/Page/AnnotationLayer.css';
import { useTranslation } from 'react-i18next';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


export const TermsGuard = ({ children }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('generic');
    const { auth, legal } = useSelector(state => state);
    const [checkboxMarcat, setCheckboxMarcat] = useState(false);
    const [haFetScroll, setHaFetScroll] = useState(false);
    const [segonsRestants, setSegonsRestants] = useState(5);
    const [tempsFinalitzat, setTempsFinalitzat] = useState(false);
    const [numPagines, setNumPagines] = useState(null);
    const intervalRef = useRef(null);
    const modalObert = !legal.haAcceptat && !legal.error && legal.document;
    const idDocument = process.env.REACT_APP_ID_DOCUMENT_LEGAL || null;
    const [botoHover, setBotoHover] = useState(false);

    useEffect(() => {
        if (auth?.idE) {
            dispatch(comprovarAcceptacioAction(auth.idE,idDocument));
            //dispatch(carregarDocumentAction());
            //Comentar setHaFetScroll i setTempsFinalitzat per eliminar el requisit de scroll i temps d'espera y descomentar dispacth quan vulguis carregar el document 
             setHaFetScroll(true);
             setTempsFinalitzat(true);
        }
    }, [auth?.idE]);

    useEffect(() => {
        if (modalObert && !tempsFinalitzat) {
            intervalRef.current = setInterval(() => {
                setSegonsRestants(prev => {
                    if (prev <= 1) {
                        clearInterval(intervalRef.current);
                        setTempsFinalitzat(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(intervalRef.current);
    }, [modalObert]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight * 0.9) {
            setHaFetScroll(true);
        }
    };

    const potAcceptar = haFetScroll && tempsFinalitzat && checkboxMarcat;
    const omplirPlaceholders = (text) => {
    return text
        .replace('{{nom}}', auth.nom || '')
        .replace('{{cognom}}', auth.cognom || '')
        .replace('{{dni}}', legal.nif || '');
};

    const handleAcceptar = () => {
        if (potAcceptar) {
            dispatch(guardarAcceptacioAction(auth.idE,idDocument));
        }
    };

    if (legal.haAcceptat === null && !legal.error) {
        return (
            <>
                {children}
                <div style={styles.overlay}>
                    <SpinerLoader />
                </div>
            </>
        );
    }

    return (
        <>
            {children}

            {(!legal.haAcceptat || legal.error) && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <h2 style={styles.titol}>{t('Legal.title')}</h2>

                        {legal.error ? (
                            <div style={styles.errorBox}>
                                <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                                    ⚠️ S'ha produït un error en carregar les condicions d'ús.
                                </p>
                                <p>
                                    Si us plau, contacti amb el suport tècnic:<br />
                                </p>
                            </div>
                        ) : (
                            <>
                                {/* <div style={styles.indicadors}>
                                    {!tempsFinalitzat && (
                                        <span style={styles.badge}>
                                            ⏱ Espera {segonsRestants}s
                                        </span>
                                    )}
                                    {!haFetScroll && (
                                        <span style={styles.badge}>
                                            📄 Desplaça't fins al final del document
                                        </span>
                                    )}
                                </div> */}

                                {/* Visor PDF amb react-pdf — scroll únic  descomnetar si es vol pDF */}
                                {/* <div
                                    style={styles.pdfContainer}
                                    onScroll={handleScroll}
                                >
                                    {legal.document?.url ? (
                                        <Document
                                            // Sense especificar → últim document
                                            file={`${process.env.REACT_APP_DOMINI_API_PORTALCOMB}/legal/pdf?idElement=${auth.idE}${idDocument ? `&idDocument=${idDocument}` : ''}`}                                            onLoadSuccess={({ numPages }) => setNumPagines(numPages)}
                                            onLoadError={(error) => console.error('Error carregant PDF:', error)}  // ← afegit
                                            loading={
                                                <div style={{ padding: '2rem', textAlign: 'center' }}>
                                                    <SpinerLoader />
                                                </div>
                                            }
                                            error={
                                                <div style={styles.errorBox}>
                                                    ⚠️ No s'ha pogut carregar el document.
                                                    <p>
                                                        Si us plau, contacti amb el suport tècnic:<br />
                                                    </p>
                                                </div>
                                            }
                                        >
                                            {Array.from(new Array(numPagines), (_, index) => (
                                                <Page
                                                    key={`page_${index + 1}`}
                                                    pageNumber={index + 1}
                                                    width={680}
                                                    renderTextLayer={false}
                                                    renderAnnotationLayer={false}
                                                />
                                            ))}
                                        </Document>
                                    ) : (
                                        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                                            <SpinerLoader />
                                        </div>
                                    )}
                                </div> */}
                                <div>
                                    <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '0 0 1rem 0' }} />                                   
                                    <div dangerouslySetInnerHTML={{ __html: omplirPlaceholders(t('Legal.htmlCondicions')) }} />
                                    <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '0 0 0 0' }} />
                                </div>
                                <label style={{
                                    ...styles.label,
                                    opacity: (haFetScroll && tempsFinalitzat) ? 1 : 0.4,
                                    cursor: (haFetScroll && tempsFinalitzat) ? 'pointer' : 'not-allowed'
                                }}>
                                    <div>
                                    <input
                                        type="checkbox"
                                        checked={checkboxMarcat}
                                        disabled={!haFetScroll || !tempsFinalitzat}
                                        onChange={(e) => setCheckboxMarcat(e.target.checked)}
                                    />
                                    {' '} { t('Legal.txtAcceptacio') }

                                    </div>
                                    </label>
                                <button
                                    disabled={!potAcceptar}
                                    onClick={handleAcceptar}
                                    onMouseEnter={() => setBotoHover(true)}
                                    onMouseLeave={() => setBotoHover(false)}
                                    style={{
                                        ...styles.button,
                                        backgroundColor: !potAcceptar ? '#44b9b7' : botoHover ? '#c1e1d5' : '#44b9b7',
                                        opacity: potAcceptar ? 1 : 0.5,
                                        cursor: potAcceptar ? 'pointer' : 'not-allowed'
                                    }}
                                >
                                    { t('Legal.acceptar') }
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.15)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
    },
    modal: {
        backgroundColor: '#fff',
        padding: '2rem',
        borderRadius: '8px',
        width: '90%',
        maxWidth: '950px',
        maxHeight: '90vh',
        overflowY: 'hidden',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
    },
    titol: {
        margin: 0,
        fontSize: '1.3rem'
    },
    indicadors: {
        display: 'flex',
        gap: '0.5rem',
        flexWrap: 'wrap'
    },
    badge: {
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '20px',
        padding: '0.3rem 0.8rem',
        fontSize: '0.85rem',
        color: '#856404'
    },
    pdfContainer: {
        flex: 1,               
        minHeight: 0,          
        overflowY: 'scroll',
        overflowX: 'hidden',
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#f5f5f5'
    },
    label: {
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: '3px',
        gap: '8px',
        transition: 'opacity 0.3s'
    },
    input: {
        marginTop: '40px'
    },
    button: {
        backgroundColor: '#44b9b7',
        color: '#fff',
        border: 'none',
        padding: '0.6rem 1.5rem',
        borderRadius: '4px',
        fontSize: '1rem',
        width: '100%',
    },
    errorBox: {
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '1rem',
        color: '#856404',
        lineHeight: '1.8'
    }
};